// import IconCheckbox from "./Inputs/IconCheckbox";
import ImageField from "./Inputs/ImageField";
import ImageInput from "./Inputs/ImageInput";
import PhotoConceptUploader from "./Inputs/PhotoConceptUploader";
import Badge from "./Badge";

import DropDown from "./Dropdown";

// Modals
import SimpleModal from "./SimpleModal";
import Modal from "./Modal";

// Tables
import BaseTable from "./Tables/BaseTable";
import SimpleTable from "./Tables/SimpleTable";
// import GlobalSalesTable from "./Tables/GlobalSalesTable";

import LoginCard from "./Cards/LoginCard";
// import ChartCard from "./Cards/ChartCard";
// import GlobalSalesCard from "./Cards/GlobalSalesCard";
// import LockCard from "./Cards/LockCard";
// import NavTabsCard from "./Cards/NavTabsCard";
// import PricingCard from "./Cards/PricingCard";
// import ProductCard from "./Cards/ProductCard";
// import SignupCard from "./Cards/SignupCard";
// import StatsCard from "./Cards/StatsCard";
// import TestimonialCard from './Cards/TestimonialCard'

import TimeLine from "./Timeline/TimeLine";
import TimeLineItem from "./Timeline/TimeLineItem";
import Tabs from "./Tabs";
import Collapse from "./Collapse";
import Slider from "./Slider";
// import SimpleWizard from "./Wizard/Wizard";
// import WizardTab from "./Wizard/WizardTab";
// import AsyncWorldMap from "./WorldMap/AsyncWorldMap";
import Pagination from "./Pagination";
import SidebarPlugin from "./SidebarPlugin";
// import AnimatedNumber from "./AnimatedNumber";

// Improting Customized Components
import CatalogTable from "./Tables/CatalogTable";
import CatalogTableAsync from "./Tables/CatalogTableAsync";
import FilterSinester from "./Sinister/Filters/Filter";
import BinnacleEntriesExtranet from "./BinnacleEntriesExtranet";
// import DialogDatas from "./Sinister/DialogDatas";
// import LocalDrawer from "./Sinister/LocalDrawer";
// import BinnacleEntries from './BinnacleEntries'

import ErrorIndicator from "./Validation/ErrorIndicator";

import Address from "./Forms/Address";
import ContactData from "./Forms/ContactData";
import FiscalData from "./Forms/FiscalData";

import SinisterSelect from "./SinisterSelect";

import TitleToolbar from "./TitleToolbar";

import FField from "./FField";
import LoadingContent from "./LoadingContent";

import UploadButton from "./UploadButton";
import DownloadFileLink from "./DownloadFileLink";

import XmlPdfLoader from "./Inputs/XmlPdfLoader";
import FileByTypeLoader from "./Inputs/FileByTypeLoader";
import PhotoList from "./Outputs/PhotoList";

import ImageWithFallback from "./ImageWithFallback";

import DialogRejectFiles from "./DialogReasonReject";

//Inputs
import FileField from "./Inputs/FileField";

export {
  CatalogTable,
  CatalogTableAsync,
  FilterSinester,
  ImageField,
  ImageInput,
  PhotoConceptUploader,
  Badge,
  SimpleModal,
  Modal,
  Pagination,
  LoginCard,
  DropDown,
  SidebarPlugin,
  TimeLine,
  TimeLineItem,
  Tabs,
  Slider,
  Collapse,
  ErrorIndicator,
  Address,
  ContactData,
  FiscalData,
  TitleToolbar,
  FField,
  LoadingContent,
  UploadButton,
  DownloadFileLink,
  PhotoList,
  SinisterSelect,
  XmlPdfLoader,
  FileByTypeLoader,
  ImageWithFallback,
  BaseTable,
  SimpleTable,
  BinnacleEntriesExtranet,
  DialogRejectFiles,
  FileField,
};



// WEBPACK FOOTER //
// ./src/components/index.js